{
  "checkIn": {
    "steps": {
      "apis": {
        "thaiDigitalArrivalCard": {
          "title": "Oletko jo täyttänyt Thaimaan digitaalisen maahantulokortin (TDAC)?",
          "content": "Kortti on täytettävä ennen maahantuloa.",
          "link": {
            "text": "Avaa maahantulokortti",
            "url": "https://tdac.immigration.go.th/arrival-card/#/home"
          }
        }
      }
    }
  },
  "services": {
    "priority": {
      "paid": "{amount} x Priority-palvelut",
      "state": {
        "purchased": {
          "default": "Priority-palvelut ei ole vielä vahvistettu",
          "plural": "{numberOfItems} Priority-palvelut vahvistettu",
          "singular": "1 Priority-palvelut vahvistettu"
        },
        "selection": {
          "default": "Ei vielä valittuja priority-palveluita",
          "plural": "{numberOfItems} Priority-palvelut odottaa ostoskorissa",
          "singular": "1 Priority-palvelut odottaa ostoskorissa"
        }
      }
    }
  }
}
